export const I18n = {
	'en': {
		noMore: '--- No selected Items ---',
		summ: 'Sum:',
		required: 'Required',
		updated: 'Updated',
		commerce: 'Commercial'
	},
	'ru': {
		noMore: '--- Нет выбранных элементов ---',
		summ: 'Всего:',
		required: 'Обязательный к установке',
		updated: 'Обновление',
		commerce: 'Маркетинг'
	},
	'sk': {
		noMore: '--- Žiadne ďalšie položky ---',
		summ: 'Sum:',
		required: 'Povinná inštalácia',
		updated: 'Aktualizovať',
		commerce: 'Komerčný'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/companyMarketAppList/index.js